import { createAction, props } from '@ngrx/store';

import { type RuntimeError } from '@blaze-runtime/engine-domain';

const TAG = '[Runtime Errors]';

export const runtimeError = createAction(`${TAG} Runtime error`, props<RuntimeError>());
